var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ position: _vm.isInApp && _vm.showTabbar ? 'relative' : 'fixed' }),attrs:{"id":"load_wrap"}},[_c('div',{staticClass:"load"},[_c('lottie',{staticClass:"lottie",attrs:{"options":_vm.options}}),_c('p',[_vm._v("加载中")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }